import wechat from './wechat.png';
import twitter from './twitter.png';
import facebook from './facebook.png';
import weibo from './weibo.png';
import youtube from './YouTube_black.png';
import qqVideo from './QQVideo_black.png';
import weiboWhite from './weiboWhite.png';
import facebookWhite from './facebookWhite.png';
import wechatWhite from './wechatWhite.png';
import bilibili from './bilibili.png';


export const STYLE_TYPE = {
    'PC': '0',
    'MOBILE': '1',
    'BIG_PC': '2',
};

export const SOCIAL_MEDIA_TYPE = {
    'WEIBO': 'weibo',
    'FACEBOOK': 'facebook',
    'WECHAT': 'wechat',
    'TWITTER': 'twitter',
    'YOUTUBE': 'youtube',
    'BILIBILI': 'BILIBILI'
};

export const SOCIAL_MEDIA_LOGOS = {
    [SOCIAL_MEDIA_TYPE.WEIBO]: weibo,
    [SOCIAL_MEDIA_TYPE.FACEBOOK]: facebook,
    [SOCIAL_MEDIA_TYPE.WECHAT]: wechat,
    [SOCIAL_MEDIA_TYPE.TWITTER]: twitter,
    [SOCIAL_MEDIA_TYPE.YOUTUBE]: youtube,
    [SOCIAL_MEDIA_TYPE.BILIBILI]: bilibili
};

export const SOCIAL_MEDIA_LINKS = {
    [SOCIAL_MEDIA_TYPE.WEIBO]: 'https://weibo.com/u/6657175136', 
    [SOCIAL_MEDIA_TYPE.FACEBOOK]: 'https://www.facebook.com/megurutraveljp',
    [SOCIAL_MEDIA_TYPE.WECHAT]: 'https://github.com/MQ-380/picture/blob/master/pngwing%2010.png?raw=true',
    [SOCIAL_MEDIA_TYPE.YOUTUBE]: 'https://www.youtube.com/channel/UCo1Xan4yKBcRb0jDKRr6C8A/featured',
    [SOCIAL_MEDIA_TYPE.BILIBILI]: 'https://space.bilibili.com/1563452302',
};

export const SOCIAL_MEDIA_LOGOS_WHITE = {
    [SOCIAL_MEDIA_TYPE.WEIBO]: weiboWhite,
    [SOCIAL_MEDIA_TYPE.FACEBOOK]: facebookWhite,
    [SOCIAL_MEDIA_TYPE.WECHAT]: wechatWhite,
}

export const themeColor = '#B69A67';
export const contact = [SOCIAL_MEDIA_TYPE.WEIBO, SOCIAL_MEDIA_TYPE.WECHAT, SOCIAL_MEDIA_TYPE.FACEBOOK, SOCIAL_MEDIA_TYPE.TWITTER];
export const homePageContact = [SOCIAL_MEDIA_TYPE.FACEBOOK, SOCIAL_MEDIA_TYPE.WEIBO, SOCIAL_MEDIA_TYPE.WECHAT, SOCIAL_MEDIA_TYPE.YOUTUBE,SOCIAL_MEDIA_TYPE.BILIBILI, ];

export const DETAIL_QUERY_NAME = 'hid';

export const fetchDomain = '3.113.71.249:8081/';
export const imageDomain = 'https://yok-meguri-prod.s3.ap-northeast-1.amazonaws.com';